"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var CloseSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 20 20", fill: "currentColor", width: size || "20", height: size || "20" }, props),
        React.createElement("path", { d: "M15.2928932,3.99989322 L16,4.707 L10.7068932,9.99989322 L16.0000534,15.2928398 L15.2929466,15.9999466 L9.99989322,10.7068932 L4.707,16 L3.99989322,15.2928932 L9.29289322,9.99989322 L4,4.707 L4.70710678,3.99989322 L9.99989322,9.29189322 L15.2928932,3.99989322 Z", fillRule: "evenodd" })));
};
CloseSmall.displayName = 'CloseSmall';
exports.default = CloseSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=CloseSmall.js.map